/**
 * @fileoverview GET handler for the "/companies/:company_id/oauth_mcp_settings/partner_policies" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettingsPartnerPolicies } from "./constants";
import type { GetCompaniesCompanyIdOauthMcpSettingsPartnerPoliciesResult } from "./types";
import { isGetCompaniesCompanyIdOauthMcpSettingsPartnerPoliciesResult } from "./validators";

export const getCompaniesCompanyIdOauthMcpSettingsPartnerPolicies = reactQueryFetcherAdapter(
  companiesCompanyIdOauthMcpSettingsPartnerPolicies,
  (signal: AbortSignal, companyId: string): Promise<GetCompaniesCompanyIdOauthMcpSettingsPartnerPoliciesResult> => {
    return fetch(`/companies/${companyId}/oauth_mcp_settings/partner_policies`, "GET", {}, { signal });
  },
  isGetCompaniesCompanyIdOauthMcpSettingsPartnerPoliciesResult
);
